import { render, staticRenderFns } from "./SettingUserDetail.vue?vue&type=template&id=050f85b7&scoped=true"
import script from "./SettingUserDetail.vue?vue&type=script&lang=js"
export * from "./SettingUserDetail.vue?vue&type=script&lang=js"
import style0 from "./SettingUserDetail.vue?vue&type=style&index=0&id=050f85b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f85b7",
  null
  
)

export default component.exports